import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "MaterialDetailViewContainer wd100 pd16 box"
};
const _hoisted_2 = {
  class: "ft30 boldFont mb20"
};
const _hoisted_3 = {
  class: "ft14 ml2",
  style: {
    "color": "grey"
  }
};
const _hoisted_4 = {
  class: "ml16 mr16"
};
const _hoisted_5 = {
  class: "button-group"
};
const _hoisted_6 = {
  class: "mt10 mb12 ft12",
  style: {
    "color": "gray"
  }
};
const _hoisted_7 = {
  key: 0,
  style: {
    "color": "red"
  },
  class: "ml16"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  class: "leftCenter mt16",
  style: {
    "flex-wrap": "wrap"
  }
};
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = ["href"];
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "leftCenter mt16",
  style: {
    "flex-wrap": "wrap"
  }
};
const _hoisted_16 = ["href"];
const _hoisted_17 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_NoteDataChart = _resolveComponent("NoteDataChart");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($data.material.title), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString($data.material.creatorName), 1), _createElementVNode("span", _hoisted_4, _toDisplayString($data.material.createdTime), 1)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
    plain: "",
    onClick: $options.download,
    class: "ml16",
    type: "primary",
    style: {
      "width": "100px"
    }
  }, {
    default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("下载素材")])),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_checkbox, {
    class: "ml10 download-checkbox",
    style: {
      "font-size": "12px",
      "margin-right": "0px",
      "vertical-align": "bottom"
    },
    modelValue: $data.downloadSourceFile,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.downloadSourceFile = $event)
  }, {
    default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("包含原始文件")])),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_button, {
    plain: "",
    class: "ml16",
    onClick: $options.copyContent,
    style: {
      "width": "100px"
    }
  }, {
    default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("复制内容")])),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    plain: "",
    class: "ml16",
    onClick: $options.copyTitle
  }, {
    default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("复制标题")])),
    _: 1
  }, 8, ["onClick"]), $data.material.owner ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    plain: "",
    class: "ml16",
    type: "success",
    onClick: $options.toEdit
  }, {
    default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("编辑")])),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.material.tags, (tag, tagi) => {
    return _openBlock(), _createBlock(_component_el_tag, {
      key: `tag_${tagi}`,
      class: "mr4 mb4",
      color: $data.tagColors[tagi % $data.tagColors.length],
      style: {
        "border": "none"
      },
      effect: "dark",
      size: "small",
      round: ""
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(tag), 1)]),
      _: 2
    }, 1032, ["color"]);
  }), 128)), $data.material.boom ? (_openBlock(), _createElementBlock("span", _hoisted_7, "爆款🔥🔥")) : _createCommentVNode("", true)]), _cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "divider"
  }, null, -1)), _createVNode(_component_el_form, {
    "label-suffix": "：",
    class: "mt12"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: "文案内容"
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        innerHTML: $data.material.content
      }, null, 8, _hoisted_8)]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "链接信息",
      class: "leftCenter mt16"
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        style: {
          "flex-wrap": "wrap"
        },
        innerHTML: $options.convertTextToHTML($data.material.links)
      }, null, 8, _hoisted_9)]),
      _: 1
    }), $data.material.noteId ? (_openBlock(), _createBlock(_component_NoteDataChart, {
      key: 0,
      "note-id": $data.material.noteId
    }, null, 8, ["note-id"])) : _createCommentVNode("", true), $data.material.noteId != null ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 1,
      label: "素材数据",
      class: "leftCenter mt16"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tag, {
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode("收藏数 " + _toDisplayString($data.material.collectedCount), 1)]),
        _: 1
      }), _createVNode(_component_el_tag, {
        class: "ml12",
        type: "success"
      }, {
        default: _withCtx(() => [_createTextVNode("留言数 " + _toDisplayString($data.material.commentCount), 1)]),
        _: 1
      }), _createVNode(_component_el_tag, {
        class: "ml12",
        type: "info"
      }, {
        default: _withCtx(() => [_createTextVNode("分享数 " + _toDisplayString($data.material.shareCount), 1)]),
        _: 1
      }), _createVNode(_component_el_tag, {
        class: "ml12",
        type: "warning"
      }, {
        default: _withCtx(() => [_createTextVNode("喜欢数 " + _toDisplayString($data.material.likedCount), 1)]),
        _: 1
      }), _createVNode(_component_el_tag, {
        class: "ml12",
        type: "danger"
      }, {
        default: _withCtx(() => [_createTextVNode("浏览数 " + _toDisplayString($data.material.viewCount), 1)]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
      label: "多媒体文件"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.material.medias, m => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: `m_${m.id}`
        }, [m.mediaType == 'IMG' ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: m.url,
          style: {
            "width": "200px",
            "border-radius": "6px"
          },
          class: "mb12 mr16"
        }, null, 8, _hoisted_11)) : _createCommentVNode("", true), m.mediaType == 'VIDEO' ? (_openBlock(), _createElementBlock("video", {
          key: 1,
          src: m.url,
          style: {
            "width": "200px",
            "border-radius": "6px"
          },
          controls: "",
          class: "mb12 mr16"
        }, null, 8, _hoisted_12)) : _createCommentVNode("", true), m.mediaType == 'FILE' ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          href: m.url,
          target: "_blank",
          class: "pd12 mr16",
          style: {
            "text-decoration": "none",
            "text-align": "center",
            "border-radius": "6px",
            "border": "lightgray 1px solid",
            "width": "100px"
          }
        }, [_createElementVNode("img", {
          src: $options.getFileIcon(m.url),
          style: {
            "width": "80px"
          },
          class: "ptr"
        }, null, 8, _hoisted_14), _cache[6] || (_cache[6] = _createElementVNode("div", {
          style: {
            "color": "gray",
            "text-decoration": "none"
          }
        }, "下载文件", -1))], 8, _hoisted_13)) : _createCommentVNode("", true)], 64);
      }), 128))])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "原始文件"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.material.sourceFiles, m => {
        return _openBlock(), _createElementBlock("a", {
          key: `m_${m.id}`,
          href: m.url,
          target: "_blank",
          class: "leftCenter pd12 mr16"
        }, [_createElementVNode("img", {
          src: $options.getFileIcon(m.url),
          style: {
            "width": "80px"
          },
          class: "ptr mb12"
        }, null, 8, _hoisted_17)], 8, _hoisted_16);
      }), 128))])]),
      _: 1
    })]),
    _: 1
  })]);
}